var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ps-container"},[_c('h1',[_vm._v(_vm._s(_vm._f("t")('Upgrade Craft CMS','app')))]),_vm._v(" "),_c('hr'),_vm._v(" "),(!_vm.loading)?[(_vm.errorMsg)?[(_vm.errorMsg)?_c('div',{staticClass:"error"},[_vm._v("\n        "+_vm._s(_vm.errorMsg)+"\n      ")]):_vm._e()]:[_c('cms-editions')]]:[_c('c-spinner')]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }